/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import { client } from "../../../Utils/axiosClient";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { PopoverDropdown } from "../../../Core/Components/CustomDropdown";
import useCommodities from "./useCommodities";
import WeightDeliveredIcon from "../../../Common/Svgs/WeightDeliveredIcon";
import { getStopSummary } from "../../../Redux/APIs/tripsAPI";

const EditProduceModal = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const { currentTrip, currentStop, editProduceModal } = useSelector(
    (state) => state.trips,
  );

  const commodities = useCommodities();

  const [selected, setSelected] = useState({
    id: editProduceModal?.data?.produceId
      ? +editProduceModal.data.produceId
      : 0,
    name: editProduceModal?.data?.produceName || "",
  });

  useEffect(() => {
    if (editProduceModal?.data) {
      setSelected({
        id: Number(editProduceModal.data.produceId) || 0,
        name: editProduceModal.data.produceName || "",
      });
    }
  }, [editProduceModal?.data]);

  const onSave = async () => {
    try {
      dispatch(updateTrips({ key: "loading", value: true }));

      const payload = {
        tripId: currentTrip?.id || 0,
        stopId: currentStop?.stopId || 0,
        farmerId: editProduceModal?.data?.farmerId || 0,
        newProduceId: selected?.id || 0,
        newProduceName: selected?.name?.toLowerCase() || "",
        isOrigin: currentStop?.isOrigin || 0,
        isDestination: currentStop?.isDestination || 0,
      };

      console.log({ payload });

      await client.post(
        `${process.env.REACT_APP_API_URL}/trip/edit-produce-for-farmer`,
        payload,
      );

      await dispatch(
        getStopSummary({
          stopId: currentStop.stopId,
          tripId: currentStop.tripId,
        }),
      );
    } catch (err) {
      console.log(err);
    } finally {
      onCancel();
      setSelected({ id: 0, name: "" });
      dispatch(updateTrips({ key: "loading", value: false }));
    }
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="420px">
      <div
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-center justify-between px-4 pt-4">
          <div className="flex items-center gap-x-3">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary">
              <WeightDeliveredIcon
                size={24}
                className="text-background-white"
              />
            </div>

            <p className="font-poppins font-medium text-base text-black">
              Produce
            </p>
          </div>

          <button type="button" className="mr-2" onClick={onCancel}>
            <CloseIcon className="stroke-dark-gray w-6 h-6" />
          </button>
        </div>

        <div className="mt-6 px-6">
          <h1 className="font-poppins text-xs font-medium text-black">
            Edit Produce
          </h1>

          <p className="mt-1 font-aileron text-xs font-normal text-dark-gray">
            Please select the new produce for this farmer.
          </p>

          <div className="mt-6">
            <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
              Select produce
            </p>

            <PopoverDropdown
              options={commodities}
              value={selected?.name || ""}
              dropdownType="edit-produce"
              placeholder="Select produce"
              onSelect={(data) =>
                setSelected({
                  id: data.key,
                  name: data.value,
                })
              }
            />
          </div>
        </div>

        <div className="p-6 flex items-center justify-end gap-x-3">
          <Button colors="grey" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          <Button colors="primary" size="primary" onClick={onSave}>
            Save Changes
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default EditProduceModal;
